<template>
  <div>
    <div class="textInput1">
      <label class="label1" for="ComboBox">{{ Title }}</label>
      <div class="input-group">
        <ComboBox
          :data-source="Data.length ? Data : []"
          :height="275"
          :class="{ errorStyle: error }"
          :maxlength="max"
          :filter="'contains'"
          :placeholder="'Select'"
          :value="Value"
          :min-filter-length="0"
          @change="$emit('onChange', $event.sender.value() ?? $event.sender.text())"
          :style="{ width: '18.6em !important' }"
          :required="true"
        >
        </ComboBox>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { ComboBox } from "@progress/kendo-dropdowns-vue-wrapper";
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    Title: {
      type: String,
      default: ""
    },
    error: {
      type: String,
      default: ""
    },
    Data: {
      type: Array,
      default: () => []
    },
    Value: {
      type: [String, Number],
      default: ""
    }
  },
  emits: ["onChange"],
  components: {
    ComboBox
  },
  data() {
    return {
      max: 30
    };
  }
});
</script>
<style scoped>
.label1 {
  font-size: 16px;
}
.textInput1 {
  height: 57px;
}
.errorStyle {
  border-color: red;
}
</style>
